import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getLectures, deleteLecture } from "../../redux/services/lectureSlice";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Table from "../../common/Table";
import ConfirmationPage from "../../common/ConfirmationPage";
import { LuPencilLine } from "react-icons/lu";
import { AiOutlineDelete } from "react-icons/ai";
import { ROUTES } from "../../constant";

const LecturesTable = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const moduleId = new URLSearchParams(location.search).get("moduleId");

  const getLectureData = useSelector((state) => state?.lecture?.lectureData);

  const [confirm, setConfirm] = useState(false);
  const [deleteId, setDeleteId] = useState(null);

  // pagination + search states
  const [page, setPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchData, setSearchData] = useState("");

  const limitOptions = [
    { value: 10, label: 10 },
    { value: 30, label: 30 },
    { value: 50, label: 50 },
    { value: 100, label: 100 },
  ];

  const getAllLectures = useCallback(async () => {
    if (moduleId) {
      await dispatch(
        getLectures({
          moduleId,
          page: page + 1,
          limit: pageLimit,
          search: searchData,
          type: "course",
        })
      );
    }
  }, [dispatch, moduleId, page, pageLimit, searchData]);

  useEffect(() => {
    getAllLectures();
  }, [getAllLectures]);

  const handleDelete = async () => {
    const res = await dispatch(deleteLecture(deleteId));
    toast.success(res?.payload?.message || "Deleted successfully");
    setConfirm(false);
    getAllLectures();
  };

  const columns = [
    { header: "S/N", key: "index", render: (_, __, index) => page * pageLimit + index + 1 },
    { header: "Title", key: "title" },
    { header: "Subtitle", key: "subtitle" },
    { header: "Language", key: "language" },
    { header: "Subject", key: "subjectName" },
    { header: "Type", key: "type" },
    { header: "isLocked", key: "isLocked", render: (isLocked) => (isLocked ? "True" : "False") },
    {
      header: "Image",
      key: "image",
      render: (img) => <img src={img} alt="lecture" className="w-20 h-14 object-cover rounded-xl" />,
    },
    {
      header: "Link",
      key: "link",
      render: (link) => (
        <a href={link} target="_blank" rel="noreferrer" className="text-primary underline">
          Visit
        </a>
      ),
    },
  ];

  const actions = [
    {
      icon: <LuPencilLine />,
      onClick: (row) =>
        navigate(`${ROUTES.COURSES.LECTURES_MODULE_ADD_EDIT}?lectureId=${row._id}`, {
          state: { row, moduleId },
        }),
    },
    {
      icon: <AiOutlineDelete />,
      onClick: (row) => {
        setDeleteId(row._id);
        setConfirm(true);
      },
    },
  ];

  return (
    <>
      <Table title="Lectures" buttonTitle="Add Lecture" showSearchbar={true} searchTerm={searchTerm} setSearchTerm={setSearchTerm} setSearchData={setSearchData} onAddClick={() => navigate(`${ROUTES.COURSES.LECTURES_MODULE_ADD_EDIT}?moduleId=${moduleId}`)} columns={columns} data={getLectureData?.lecture_data || []} actions={actions} pageCount={getLectureData?.state?.page_limit} onPageChange={(selectedItem) => setPage(selectedItem.selected)} pageLimitOptions={limitOptions} selectedPageLimit={pageLimit} onPageLimitChange={setPageLimit} />

      {confirm && <ConfirmationPage topicName="Lecture" confirm={confirm} onDelete={handleDelete} onCancel={() => setConfirm(false)} />}
    </>
  );
};

export default LecturesTable;
